import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { setPdfWorkerSrc } from '@solusign/platform/pdf';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.mjs?url';
import App from './App.vue';
import { router } from './router';
import './styles.css';

// WHY: pdfjs-dist resolves its worker URL relative to the running document by default,
// which breaks in a Vite-served SPA (CSP blocks the CDN fallback). `?url` fait résoudre
// par Vite l'URL servie du worker (même origine), contrairement à `new URL(bare, ...)`.
setPdfWorkerSrc(pdfWorkerUrl);

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
